import React, { Component } from 'react';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/tr';
import 'react-big-calendar/lib/css/react-big-calendar.css';

import Login from '../Login/Login.js';
import Sidebar from '../Sidebar/Sidebar.js';
import Dashboard from '../Dashboard/Dashboard.js';
import PatientList from '../Patient/PatientList.js';
import PatientDetails from '../Patient/PatientDetails.js';
import AppointmentCalendar from '../Appointment/AppointmentCalendar.js';
import NewAppointmentModal from '../Modal/NewAppointmentModal.js';
import NewPatientModal from '../Modal/NewPatientModal.js'; // Import NewPatientModal
import './ClinicPro.css';

moment.locale('tr');
const localizer = momentLocalizer(moment);

const DEMO_USERS = [
    { username: 'doktor', password: '1234', role: 'DOKTOR', name: 'Dr. Mehmet Kaya' },
    { username: 'sekreter', password: '1234', role: 'SEKRETER', name: 'Ayşe Yılmaz' }
];

const ROLES = {
    DOKTOR: {
        name: 'Doctor',
        permissions: { addPatient: true, viewPatient: true, editPatient: true, viewDocument: true, addDocument: true, addExamination: true, viewReports: true, manageAppointments: true, }
    },
    SEKRETER: {
        name: 'Secretary',
        permissions: { addPatient: true, viewPatient: true, editPatient: true, viewDocument: false, addDocument: false, addExamination: false, viewReports: false, manageAppointments: true, }
    }
};

class ClinicPro extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoggedIn: false,
            currentUser: null,
            activeTab: 'dashboard',
            patients: [
                { id: 1, firstName: 'Ayşe', lastName: 'Yılmaz', nationalId: '12345678901', phone: '0532 123 45 67', birthDate: '1990-05-15', email: 'ayse.yilmaz@email.com', bloodType: 'A+', chronicDisease: 'None', lastExamination: '2025-12-18', status: 'Active', notes: 'Requires regular check-ups.', documents: [], examinations: [{ id: 1, date: '2025-12-18', complaint: 'Headache and fatigue', diagnosis: 'Migraine', treatment: 'Painkiller prescribed', doctor: 'Dr. Mehmet Kaya' }] },
                { id: 2, firstName: 'Mehmet', lastName: 'Demir', nationalId: '98765432109', phone: '0533 987 65 43', birthDate: '1985-08-22', email: 'mehmet.demir@email.com', bloodType: 'O+', chronicDisease: 'Hypertension', lastExamination: '2025-12-18', status: 'Follow-up', notes: 'Blood pressure monitoring.', documents: [], examinations: [{ id: 1, date: '2025-12-18', complaint: 'Blood pressure check', diagnosis: 'Hypertension control', treatment: 'Medication dosage adjusted', doctor: 'Dr. Mehmet Kaya' }] },
            ],
            appointments: [
                { id: 1, title: 'Ayşe Yılmaz - Check-up', start: new Date(2025, 11, 19, 10, 0), end: new Date(2025, 11, 19, 10, 30), patientId: 1, notes: 'Annual check-up' },
                { id: 2, title: 'Mehmet Demir - BP Check', start: new Date(2025, 11, 20, 14, 0), end: new Date(2025, 11, 20, 14, 30), patientId: 2, notes: 'Monthly blood pressure measurement.' },
            ],
            selectedPatient: null,
            searchText: '',
            patientFilter: 'All',
            isNewPatientModalOpen: false,
            isNewAppointmentModalOpen: false,
            selectedAppointment: null,
            newAppointmentDetails: { patientId: '', date: '', time: '', notes: '' },
        };
    }

    handleLogin = (username, password, role) => {
        const user = DEMO_USERS.find(u => u.username === username && u.password === password && u.role === role);
        if (user) {
            this.setState({ currentUser: user, isLoggedIn: true });
        } else {
            alert('Invalid username, password, or role!');
        }
    };

    handleLogout = () => {
        this.setState({ isLoggedIn: false, currentUser: null, activeTab: 'dashboard' });
    };
    
    hasPermission = (permission) => {
        const { currentUser } = this.state;
        if (!currentUser) return false;
        return ROLES[currentUser.role].permissions[permission];
    };

    handleTabChange = (tabName) => {
        this.setState({ activeTab: tabName });
    };

    handlePatientSearch = (e) => {
        this.setState({ searchText: e.target.value });
    };

    handlePatientFilter = (filter) => {
        this.setState({ patientFilter: filter });
    };

    getFilteredPatients = () => {
        const { patients, searchText, patientFilter } = this.state;
        return patients.filter(patient => {
            const searchLower = searchText.toLowerCase();
            const nameMatches = `${patient.firstName} ${patient.lastName}`.toLowerCase().includes(searchLower);
            const idMatches = patient.nationalId.includes(searchLower);
            const phoneMatches = patient.phone.includes(searchLower);
            
            const filterMatches = patientFilter === 'All' || patient.status === patientFilter;

            return (nameMatches || idMatches || phoneMatches) && filterMatches;
        });
    };

    openNewPatientModal = () => this.setState({ isNewPatientModalOpen: true });

    handlePatientSave = (newPatientData) => {
        if (!newPatientData.firstName || !newPatientData.lastName || !newPatientData.nationalId) {
            alert('First Name, Last Name, and National ID are required.');
            return;
        }
        const newId = this.state.patients.length > 0 ? Math.max(...this.state.patients.map(p => p.id)) + 1 : 1;
        const newPatient = {
            ...newPatientData,
            id: newId,
            status: 'Active',
            documents: [],
            examinations: [],
            lastExamination: new Date().toISOString().split('T')[0],
        };
        this.setState(prevState => ({
            patients: [...prevState.patients, newPatient],
            isNewPatientModalOpen: false,
        }));
        alert('Patient added successfully!');
    };
    
    handleNewAppointmentClick = () => {
        this.setState({ isNewAppointmentModalOpen: true, selectedAppointment: null, newAppointmentDetails: { patientId: '', date: moment().format('YYYY-MM-DD'), time: moment().format('HH:mm'), notes: '' } });
    };

    handleSelectSlot = (slotInfo) => {
        if (!this.hasPermission('manageAppointments')) return;
        this.setState({
            isNewAppointmentModalOpen: true,
            selectedAppointment: null,
            newAppointmentDetails: {
                patientId: '',
                date: moment(slotInfo.start).format('YYYY-MM-DD'),
                time: moment(slotInfo.start).format('HH:mm'),
                notes: ''
            }
        });
    };

    handleSelectEvent = (event) => {
        if (!this.hasPermission('manageAppointments')) return;
        const patient = this.state.patients.find(p => p.id === event.patientId);
        this.setState({
            isNewAppointmentModalOpen: true,
            selectedAppointment: { ...event, patient },
            newAppointmentDetails: {
                patientId: event.patientId,
                date: moment(event.start).format('YYYY-MM-DD'),
                time: moment(event.start).format('HH:mm'),
                notes: event.notes || ''
            }
        });
    };

    handleAppointmentSave = (appointmentDetails) => {
        const { appointments, patients } = this.state;
        const patient = patients.find(p => p.id === parseInt(appointmentDetails.patientId));

        if (!patient) {
            alert('Invalid patient selected.');
            return;
        }

        const [year, month, day] = appointmentDetails.date.split('-');
        const [hour, minute] = appointmentDetails.time.split(':');
        const start = new Date(year, parseInt(month) - 1, day, hour, minute);
        const end = moment(start).add(30, 'minutes').toDate();

        if (this.state.selectedAppointment) {
            this.setState(prevState => ({
                appointments: prevState.appointments.map(app =>
                    app.id === prevState.selectedAppointment.id
                        ? { ...app, title: `${patient.firstName} ${patient.lastName} - Appointment`, start, end, patientId: patient.id, notes: appointmentDetails.notes }
                        : app
                ),
                isNewAppointmentModalOpen: false,
                selectedAppointment: null,
            }));
            alert('Appointment updated successfully!');
        } else {
            const newId = appointments.length > 0 ? Math.max(...appointments.map(a => a.id)) + 1 : 1;
            this.setState(prevState => ({
                appointments: [...prevState.appointments, { id: newId, title: `${patient.firstName} ${patient.lastName} - Appointment`, start, end, patientId: patient.id, notes: appointmentDetails.notes }],
                isNewAppointmentModalOpen: false,
            }));
            alert('Appointment added successfully!');
        }
    };
    
    handleAppointmentDelete = (appointmentId) => {
        if (window.confirm('Are you sure you want to delete this appointment?')) {
            this.setState(prevState => ({
                appointments: prevState.appointments.filter(app => app.id !== appointmentId),
                isNewAppointmentModalOpen: false,
                selectedAppointment: null,
            }));
            alert('Appointment deleted successfully!');
        }
    };

    handlePatientEdit = () => {
        // TODO: Implement patient edit modal
        alert('Patient edit functionality will be implemented soon.');
    };

    handleNewExamination = () => {
        // TODO: Implement new examination modal
        alert('New examination functionality will be implemented soon.');
    };

    handleNewDocument = () => {
        // TODO: Implement new document upload
        alert('Document upload functionality will be implemented soon.');
    };

    renderContent = () => {
        const { activeTab, selectedPatient, appointments } = this.state;

        switch (activeTab) {
            case 'dashboard':
                const stats = {
                    totalPatients: this.state.patients.length,
                    activePatients: this.state.patients.filter(p => p.status === 'Active').length,
                    followUpPatients: this.state.patients.filter(p => p.status === 'Follow-up').length,
                    todayAppointments: 0,
                };
                return <Dashboard currentUser={this.state.currentUser} stats={stats} onNewPatientClick={this.openNewPatientModal} onNewAppointmentClick={this.handleNewAppointmentClick} hasPermission={this.hasPermission} />;
            case 'patients':
                return <PatientList patients={this.getFilteredPatients()} searchText={this.state.searchText} onSearchChange={this.handlePatientSearch} activeFilter={this.state.patientFilter} onFilterChange={this.handlePatientFilter} onPatientClick={(patient) => this.setState({ selectedPatient: patient, activeTab: 'patientDetails' })} onNewPatientClick={this.openNewPatientModal} hasPermission={this.hasPermission} />;
            case 'patientDetails':
                return <PatientDetails patient={selectedPatient} onBack={() => this.setState({ activeTab: 'patients', selectedPatient: null })} onEdit={this.handlePatientEdit} onNewExamination={this.handleNewExamination} onNewDocument={this.handleNewDocument} hasPermission={this.hasPermission} />;
            case 'appointments':
                return <AppointmentCalendar appointments={appointments} onSelectSlot={this.handleSelectSlot} onSelectEvent={this.handleSelectEvent} onNewAppointmentClick={this.handleNewAppointmentClick} hasPermission={this.hasPermission} />;
            case 'reports':
                return <p>Content for {activeTab} goes here.</p>;
            default:
                return <p>Welcome!</p>;
        }
    };

    render() {
        if (!this.state.isLoggedIn) {
            return <Login onLogin={this.handleLogin} />;
        }
        
        const userWithRoleName = {
            ...this.state.currentUser,
            roleName: ROLES[this.state.currentUser.role].name
        };

        return (
            <div className="main-container">
                <Sidebar
                    currentUser={userWithRoleName}
                    activeTab={this.state.activeTab}
                    onTabChange={this.handleTabChange}
                    onLogout={this.handleLogout}
                    hasPermission={this.hasPermission}
                />
                <main className="main-content">
                    {this.renderContent()}
                </main>
                
                <NewAppointmentModal
                    isOpen={this.state.isNewAppointmentModalOpen}
                    onClose={() => this.setState({ isNewAppointmentModalOpen: false, selectedAppointment: null })}
                    onSave={this.handleAppointmentSave}
                    onDelete={this.handleAppointmentDelete}
                    newAppointmentDetails={this.state.newAppointmentDetails}
                    onDetailsChange={(details) => this.setState({ newAppointmentDetails: details })}
                    patients={this.state.patients}
                    selectedAppointment={this.state.selectedAppointment}
                />
                
                <NewPatientModal
                    isOpen={this.state.isNewPatientModalOpen}
                    onClose={() => this.setState({ isNewPatientModalOpen: false })}
                    onSave={this.handlePatientSave}
                />
            </div>
        );
    }
}

export default ClinicPro;